import React, { Component } from 'react';

import { Graphics } from './components/Graphics';

// Styles
import './style.scss';

export class HeatBlock extends Component {

  componentWillMount(){
    this.props.createHeatBlock({
      props: this.props.defaultProps
    })
  }

    // // showHeatBlockModal = () => {
    // //     this.props.setModal({
    // //         type: 'HEATBLOCK_CONTROLS',
    // //         size: 'lg',
    // //         connect: this.props.id
    // //       });
    // //     this.props.showModal({display: true});
    // // }
    //
    // showHeatBlockTubes = () => {
    //     this.props.setModal({
    //         type: 'HEATBLOCK_TUBES',
    //         size: 'lg',
    //         connect: this.props.id
    //       });
    //     this.props.showModal({display: true});
    // }

    render() {
        return (
            <ul>
                <li
                    id={"HeatBlock_"+this.props.id}
                    className="HeatBlock dropTarget"
                    onClick={this.showHeatBlockTubes}>
                    {/* <p className="label" aria-hidden="true">Heat Block</p> */}
                    <div id={"HeatBlock_"+this.props.id} class="heatBlockTarget"></div>
                    <Graphics id={this.props.id} />
                </li>
            </ul>
        )
    }
}
